import { isInternalTrafficEnabled } from './internalTraffic'
import { isAnalyticsDomainAllowed } from './domainGuard'

// Helper functions for tracking events
export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    ;(window as any).gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
  }
}

export const trackPageView = (url: string) => {
  if (
    typeof window !== 'undefined' &&
    (window as any).gtag &&
    isAnalyticsDomainAllowed()
  ) {
    const config: Record<string, string> = {
      page_path: url,
    }

    if (isInternalTrafficEnabled()) {
      config.traffic_type = 'internal'
    }

    ;(window as any).gtag('config', process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID, config)
  }
}

export const applyInternalTrafficConfig = () => {
  if (
    typeof window !== 'undefined' &&
    (window as any).gtag &&
    process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID &&
    isAnalyticsDomainAllowed() &&
    isInternalTrafficEnabled()
  ) {
    ;(window as any).gtag('config', process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID, {
      traffic_type: 'internal',
    })
  }
}
